import { createSlice } from '@reduxjs/toolkit';

import { AsyncStatus } from '../_declarations/globals';
import { fetchTokenAsync } from '../api/auth';

interface AuthState {
  creationDate?: number;
  error?: string;
  expiresIn?: number;
  status?: AsyncStatus;
  value?: string;
}

const authInitialState: AuthState = {};

const authSlice = createSlice({
  extraReducers: (builder) => {
    builder
      .addCase(fetchTokenAsync.pending, (state) => {
        state.status = 'loading';
      })
      .addCase(fetchTokenAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = `${action.payload.token_type} ${action.payload.access_token}`;
        state.expiresIn = action.payload.expires_in;
        state.creationDate = Date.now();
      })
      .addCase(fetchTokenAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.error = action.error.message;
      });
  },
  initialState: authInitialState,
  name: 'auth',
  reducers: {}
});

export default authSlice.reducer;
